import { CoinLogo } from "@app/components";
import { COLORS } from "@app/constants";
import { goTo } from "@app/hooks/navigation";
import { useIndexPrice } from "@app/hooks/trade/indexprice";
import BigNumber from "bignumber.js";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { MText, MView } from "@/styles/mobilePageStyles";
import { ThemeContext } from "@/theme/ThemeProvider";
import { HotCoinItemSection } from "./styles";
import { Sparklines, SparklinesCurve } from "react-sparklines";

const HotCoinItemsNoData = ({ item }) => {
  const navigation = useNavigate();
  const { textsilver, textw } = useContext(ThemeContext).theme.COLORS;

  const { getPrice } = useIndexPrice(item?.id);

  const rateBackground = COLORS.black;

  return (
    <HotCoinItemSection
      onClick={() => {
        goTo(navigation, `/trade/${item?.id}`);
      }}
    >
      <MView
        style={{
          height: "15%",
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <CoinLogo src={item?.image} size={20} />
        <MText style={{ marginLeft: 5 }}>{item?.symbol}</MText>
        <MText style={{ marginLeft: 5, color: textsilver }}>
          {item?.sub_symbol}
        </MText>
      </MView>
      <MView
        style={{
          width: "100%",
          height: "60%",
          justifyContent: "center",
          flexDirection: "row",
        }}
      >
        <MView
          style={{
            width: "15%",
            height: "100%",
            justifyContent: "center",
          }}
        >
          <MView
            style={{
              height: "70%",
              width: 3,
              background: rateBackground,
              borderRadius: 10,
            }}
          />
        </MView>
        <MView
          style={{
            width: "75%",
            height: "80%",
            justifyContent: "space-between",
            alignSelf: "center",
            paddingBlock: 5,
          }}
        >
          <MText style={{ color: textsilver }}>Spot</MText>
          <MText style={{ color: textw }}>
            {BigNumber(getPrice(item?.id) || 0).toFormat(2)}
          </MText>
          <MText style={{ color: rateBackground, fontSize: 12 }}>{"- %"}</MText>
        </MView>
      </MView>
      <MView
        style={{
          height: "25%",
          width: "100%",
        }}
      >
        <Sparklines data={[]}>
          <SparklinesCurve />
        </Sparklines>
      </MView>
    </HotCoinItemSection>
  );
};

export default React.memo(HotCoinItemsNoData);
